// extracted by mini-css-extract-plugin
export default {"titleContainer":"LoginForm_titleContainer__AMBlX","inputBox":"LoginForm_inputBox__1KpgO","button":"LoginForm_button__iVwom","errorLabel":"LoginForm_errorLabel__MmyNE"};